import { CookieIcon } from "lucide-react";
import { Button } from "./ui/button";
import React, { useEffect, useState } from "react";
import { cn } from "../lib/utils";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { Config } from "../utils/config";

export default function CookieConsent({
  demo = false,
  onAcceptCallback = () => {},
  onDeclineCallback = () => {},
  restaurantDetail,
}) {
  let domain;
  if (
    restaurantDetail?.websiteUrl &&
    restaurantDetail?.isCnameVerified === true
  ) {
    domain = `${restaurantDetail?.websiteUrl}`;
  } else if (restaurantDetail?.subDomain) {
    domain = `${restaurantDetail?.subDomain}`;
  } else {
    domain = `${Config.env.app.sso_cookie_domain}`;
  }
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [hide, setHide] = useState(false);

  const accept = () => {
    setIsOpen(false);
    const cookieConsentData = {
      eventType: "cookieConsent",
      domain: domain,
    };

    window.parent.postMessage(cookieConsentData, "*");
    localStorage.setItem("cookieConsent", "true");

    setTimeout(() => {
      setHide(true);
    }, 700);
    onAcceptCallback();
  };

  const decline = () => {
    setIsOpen(false);
    setTimeout(() => {
      setHide(true);
    }, 700);
    onDeclineCallback();
  };

  useEffect(() => {
    try {
      setIsOpen(true);
      let cookie: any = Cookies.get("cookieConsent");
      cookie = localStorage.getItem("cookieConsent");

      if (cookie) {
        setIsOpen(false);
        setHide(true);
      }
    } catch (e) {
      // console.log("Error: ", e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={cn(
        "fixed z-[200] bottom-0 right-0 sm:right-4 sm:bottom-4 w-full sm:max-w-md duration-700",
        !isOpen
          ? "transition-[opacity,transform] translate-y-8 opacity-0"
          : "transition-[opacity,transform] translate-y-0 opacity-100",
        hide && "hidden"
      )}
    >
      <div className="dark:bg-card bg-background rounded-md  border border-border shadow-lg">
        <div className="grid gap-2">
          <div className="border-b border-border h-14 flex items-center justify-between p-4">
            <h1 className="text-lg font-medium">{t("cookie_consent.title")}</h1>
            <CookieIcon className="h-[1.2rem] w-[1.2rem]" />
          </div>
          <div className="p-4">
            <p className="text-sm font-normal text-start">
              {t("cookie_consent.description")}
              <br />
              <br />
              <p>
                {/* bullet points */}
                <ul className="list-disc list-inside space-y-2">
                  <li>
                    <span className="font-bold">
                      {t("cookie_consent.purpose.1")}{" "}
                    </span>
                    {t("cookie_consent.purpose.1_1")}
                  </li>
                  <li>
                    <span className="font-bold">
                      {t("cookie_consent.purpose.2")}{" "}
                    </span>
                    {t("cookie_consent.purpose.2_1")}
                  </li>
                  <li>
                    <span className="font-bold">
                      {t("cookie_consent.purpose.3")}{" "}
                    </span>
                    {t("cookie_consent.purpose.3_1")}
                  </li>
                </ul>
              </p>
            </p>
          </div>
          <div className="flex gap-2 p-4 py-5 border-t border-border dark:bg-background/20">
            <Button onClick={accept} className="w-full">
              {t("cookie_consent.accept")}
            </Button>
            <Button onClick={decline} className="w-full" variant="secondary">
              {t("cookie_consent.reject")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
